import {API} from "@constants";

export const MY_ACCOUNT_INFO_PATH = `${API}/myAccount`
export const MY_ACCOUNT_PASSWORD_PATH = `${API}/myAccount/password`
export const COUNTRIES_API = `${API}/myAccount/countries`
export const getStatesApi = (countryCode: string): string => `${API}/myAccount/${countryCode}/states`;
